<template>
  <main
    style="
      min-height: 100vh;
      display: grid;
      place-items: center;
      text-align: center;
    "
  >
    <div>
      <h1>{{ msg }}</h1>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      msg: "系統維護中，暫停使用",
    };
  },
  components: {},
  methods: {
    getWordingCount2(coupon) {
      const count = coupon.useCouponLimit - coupon.useCouponCount;
      return count;
    },
  },
  mounted() {
    let msgFromServer = this.$route.query.msg;
    if (msgFromServer) {
      this.msg = msgFromServer;
    }
  },
};
</script>
<style></style>
